import { createContext, type ReactNode } from 'react';

/**
 * The saved canvas's own version list (its history reader and open-version path), offered to an App page whose host has
 * no Versions data. `wanted` turns the reader on only while the Versions tab is open; `panel` is null until it is.
 */
export type SavedVersionsSlot = { wanted: (on: boolean) => void; panel: ReactNode };
export const SavedVersionsSlotContext = createContext<SavedVersionsSlot | null>(null);
